/* FAQ: filter op onderwerp, zoeken (zonder accenten), nette lege staat. */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('lp-faq')) return;
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l'); }
  customElements.define('lp-faq', class extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.lpfaq__item'));
      this.chips = Array.from(this.querySelectorAll('[data-faq-topic]'));
      this.input = this.querySelector('[data-faq-search]');
      this.empty = this.querySelector('[data-faq-empty]');
      this.topic = '';
      this.index = this.items.map(function (d) { return norm(d.textContent); });
      var self = this;
      this.chips.forEach(function (c) {
        c.addEventListener('click', function () { self.topic = c.getAttribute('data-faq-topic'); self.apply(); });
      });
      if (this.input) this.input.addEventListener('input', function () { self.apply(); });
    }
    apply() {
      var q = norm(this.input ? this.input.value.trim() : ''), self = this, shown = 0;
      this.chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-faq-topic') === self.topic ? 'true' : 'false'); });
      this.items.forEach(function (d, i) {
        var ok = (!self.topic || d.getAttribute('data-topic') === self.topic) && (!q || self.index[i].indexOf(q) > -1);
        d.hidden = !ok;
        if (ok) shown++;
      });
      if (this.empty) { this.empty.hidden = shown > 0; this.empty.textContent = shown > 0 ? '' : this.getAttribute('data-empty'); }
    }
  });
})();
